import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import * as html2pdf from 'html2pdf.js';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { toWords } from 'number-to-words';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-third-party-pay-receipt',
  templateUrl: './third-party-pay-receipt.component.html',
  styleUrls: ['./third-party-pay-receipt.component.scss']
})
export class ThirdPartyPayReceiptComponent implements OnInit {
  @ViewChild('contentToConvert') contentToConvert!: ElementRef;
  
  payHistory: FormGroup;
  payHistoryData: any[] = [];
  addmissionData: any;
  clgName: any;
  CoName: any;
  SnNo: any;
  personaldetails: any;
  TotalPaidAmountInWords: any;
  PreFix: any;
  formattedPrn: any;
  StuName: any;
  RegnNo: any;
  InstuName: string;
  currentDate: Date;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  StudentId: any;
  payModeee: string;
  TotalPaidAmount: number;
  showDownloadButton = true;
  generatingPDF = false;
  downloadingPDF: boolean = true;
  Currency: string = 'INR';
  reciptNumber: string;
  RgNo: any;
  receiptData: any;
  isVOD: boolean = true;
  isLoading: boolean = false;
  apiData: any = null;

  constructor(
    private fb: FormBuilder,
    public umsService: UmsService,
    public dialogRef1: MatDialogRef<ThirdPartyPayReceiptComponent>,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.payHistory = this.fb.group({});
  }

  ngOnInit(): void {
    this.receiptData = this.data;
    this.currentDate = new Date();
    this.StudentId = this.data.StuId;
    this.RgNo = this.data.RgNo || this.data.StuPRN;
    
    if (!this.payHistory) {
      this.payHistory = this.fb.group({});
    }
    
    this.getSecretData();
    this.prepopulationOfAddmission();
  }

  transPRN(RgNo) {
    if (RgNo) {
      this.formattedPrn = RgNo.toString().padStart(8, '0');
    } else if (this.data.RgNo) {
      this.formattedPrn = this.data.RgNo.toString().padStart(8, '0');
    }
  }

  getSecretData() {
    this.umsService.getSecretData().subscribe({
      next: (res) => {
        this.SnNo = res.projectPharam['SnNo'];
        this.InstuName = res.projectPharam['InstituteName'];
        
   
        this.fetchPaymentDetailsFromAPI();
      },
      error: (error) => {
        console.error('Error fetching secret data:', error);
        this.fetchPaymentDetailsFromAPI();
      }
    });
  }

  fetchPaymentDetailsFromAPI() {
    this.isLoading = true;
    this.spinner.show();

 
    let sessionId = this.data.SnNo || this.data.Session || this.SnNo || 0;
    
  
    if (sessionId === 0) {
      const sessionData = JSON.parse(sessionStorage.getItem('session') || '{}');
      sessionId = sessionData?.SnNo || 0;
    }

    const payload = {
      CertType: this.data.FeeType || this.data.CertType || 'VOD',
      TclcId: this.data.TclcId || 0,
      OrgId: this.data.OrgId || 0
    };

    console.log('Fetching payment details with payload:', payload);

    this.umsService.SearchOrgFeeRept(payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.spinner.hide();
        
        console.log('API Response:', res);
        
        if (res.status && res.data && res.data.length > 0) {
          this.apiData = res.data[0];
          console.log('Payment data received:', this.apiData);
          
       
          this.updateReceiptWithAPIData();
        } else {
          console.log('No payment data found, using provided data');
          
          this.processVODPayment();
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.spinner.hide();
        console.error('Error fetching payment details:', error);
   
        this.processVODPayment();
      }
    });
  }


  updateReceiptWithAPIData() {
    if (!this.apiData) {
      this.processVODPayment();
      return;
    }

    this.reciptNumber = this.apiData.ReceiptNo || 
                        this.apiData.PaymentResponseId || 
                        this.data.ReceiptNo || 
                        this.generateReceiptNumber();
    
    this.payModeee = this.apiData.PayModeTitle || 
                     this.apiData.Mode || 
                     this.data.PayModeTitle || 
                     'Online Payment';
    
    this.TotalPaidAmount = this.apiData.Amount || this.data.Amount || 0;
    this.convert(this.TotalPaidAmount);
    this.Currency = this.apiData.Currency || 'INR';


    this.payHistoryData = [];
    const paymentDate = this.apiData.PaymentDate || this.data.PaymentDate || new Date();

    if (this.apiData.FeeTemplateCode) {
     
      this.payHistoryData.push({
        FeeHead: this.apiData.ApplicationModule || 'Application Fee',
        FeeAmt: this.apiData.Amount || 0,
        FeePaymentDate: paymentDate
      });
      
      if (this.apiData.TxnNumber) {
        this.payHistoryData.push({
          FeeHead: 'Transaction Number',
          FeeAmt: this.apiData.TxnNumber,
          FeePaymentDate: paymentDate
        });
      }
    } else {
      
      this.processVODPayment();
    }
  }

  processVODPayment() {
   
    this.reciptNumber = this.data.ReceiptNo || this.data.PaymentResponseId || this.generateReceiptNumber();
    this.payModeee = this.data.PayModeTitle || this.data.Mode || 'Online Payment';
    this.TotalPaidAmount = this.data.Amount || 0;
    this.convert(this.TotalPaidAmount);
    this.Currency = 'INR';

    this.payHistoryData = [];
    const paymentDate = this.data.PaymentDate || new Date();

    
    const BASE_AMOUNT = 3050;
    const SOFT_COPY_FEE = 800;
    const HARD_COPY_FEE = 2570;


    const deliveryOpt = this.data.DeliveryOpt || 'Both';
    
    let softCopy = 0;
    let hardCopy = 0;

    if (deliveryOpt === 'Soft' || deliveryOpt === 'Both') {
      softCopy = SOFT_COPY_FEE;
    }
    if (deliveryOpt === 'Hard' || deliveryOpt === 'Both') {
      hardCopy = HARD_COPY_FEE;
    }

    
    this.payHistoryData.push({
      FeeHead: 'Base Amount',
      FeeAmt: BASE_AMOUNT,
      FeePaymentDate: paymentDate
    });

  
    this.payHistoryData.push({
      FeeHead: 'Copies Fee',
      FeeAmt: 0,
      FeePaymentDate: paymentDate
    });

    if (softCopy > 0) {
      this.payHistoryData.push({
        FeeHead: 'Soft Copy Delivery Fee',
        FeeAmt: softCopy,
        FeePaymentDate: paymentDate
      });
    }

    if (hardCopy > 0) {
      this.payHistoryData.push({
        FeeHead: 'Hard Copy Delivery Fee',
        FeeAmt: hardCopy,
        FeePaymentDate: paymentDate
      });
    }

   
    const totalCalculated = BASE_AMOUNT + softCopy + hardCopy;
    if (this.TotalPaidAmount !== totalCalculated) {
      const remaining = this.TotalPaidAmount - totalCalculated;
      if (remaining > 0) {
        this.payHistoryData.push({
          FeeHead: 'Additional Charges',
          FeeAmt: remaining,
          FeePaymentDate: paymentDate
        });
      }
    }
  }

  generateReceiptNumber(): string {
    const randomNumber = Math.floor(Math.random() * 100000);
    return randomNumber.toString().padStart(5, '0');
  }

  convert(number) {
    if (number && number > 0) {
      this.TotalPaidAmountInWords = toWords(number);
    }
  }

  prepopulationOfAddmission() {
    let payload = {};
    payload['StuId'] = this.data.StuId;
    
    this.umsService.fetchAddmissionDetails(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.addmissionData = res.data[0];
          this.getclg(res.data[0]);
          this.getCourse(res.data[0]);
        }
      },
      error: (error) => {
        console.error('Error fetching admission details:', error);
      }
    });

    this.umsService.fetchPersonalDetails(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.personaldetails = res.data[0];
          this.FirstName = res.data[0]['StuFirstNameEng'] || '';
          this.MiddleName = res.data[0]['StuMidNameEng'] || '';
          this.LastName = res.data[0]['StuLastNameEng'] || '';
          this.RgNo = res.data[0]['StuRgNo'];
          this.transPRN(this.RgNo);
          this.StuName = `${this.FirstName} ${this.MiddleName} ${this.LastName}`.trim();
        } else {
          this.clgName = this.data.College;
          this.CoName = this.data.Course;
          this.StuName = this.data.StuName;
          this.transPRN(this.RgNo);
        }
      },
      error: (error) => {
        console.error('Error fetching personal details:', error);
        this.clgName = this.data.College;
        this.CoName = this.data.Course;
        this.StuName = this.data.StuName;
      }
    });
  }

  getclg(data) {
    let payload = {};
    payload['CgCode'] = data.StuCgId;
    this.umsService.getCollege(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.clgName = res.data[0].CgName;
        } else {
          this.clgName = this.data.College;
        }
      },
      error: () => {
        this.clgName = this.data.College;
      }
    });
  }

  getCourse(data) {
    let payload = {};
    payload['CoCode'] = data.StuCoId;
    this.umsService.fetchCourseType(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.CoName = res.data[0].CoName;
          this.PreFix = res.data[0].CoRgPrfx;
        } else {
          this.CoName = this.data.Course;
          this.PreFix = '';
        }
      },
      error: () => {
        this.CoName = this.data.Course;
        this.PreFix = '';
      }
    });
  }

  downloadAsPDF() {
    this.generatingPDF = true;
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const filename = `ThirdPartyReceipt_${formattedDate}.pdf`;

    const options = {
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    const element = this.contentToConvert.nativeElement;
    const buttons = element.querySelectorAll('button');
    buttons.forEach(button => {
      button.style.display = 'none';
    });

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        buttons.forEach(button => {
          button.style.display = '';
        });
        this.generatingPDF = false;
      })
      .catch(() => {
        buttons.forEach(button => {
          button.style.display = '';
        });
        this.generatingPDF = false;
      });
  }

  close() {
    this.dialogRef1.close();
  }
}